// useDashboardMetrics - Sprint 51.
// Hook de carga de metricas del dashboard. Llama los 4 endpoints
// premium del backend (Sprint 50 Fase 2):
//   GET /api/dashboard_premium/kpis
//   GET /api/dashboard_premium/top_productos
//   GET /api/dashboard_premium/top_clientes
//   GET /api/dashboard_premium/ventas_por_mes
//
// Reemplaza los endpoints legacy /dashboard/resumen y
// /dashboard/serie-inventario (NO existen en el backend).
// apiClient.get() devuelve el payload JSON directamente
// (no envuelto en { data }).
import { useCallback, useEffect, useState } from 'react';
import apiClient from '../../../api/apiClient';

const INITIAL_KPIS = null;
const INITIAL_LIST = [];

export default function useDashboardMetrics() {
  const [kpis,         setKpis]         = useState(INITIAL_KPIS);
  const [topProductos, setTopProductos] = useState(INITIAL_LIST);
  const [topClientes,  setTopClientes]  = useState(INITIAL_LIST);
  const [ventasPorMes, setVentasPorMes] = useState(INITIAL_LIST);
  const [loading,      setLoading]      = useState(true);
  const [err,          setErr]          = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    try {
      const [r1, r2, r3, r4] = await Promise.all([
        apiClient.get('/dashboard_premium/kpis'),
        apiClient.get('/dashboard_premium/top_productos'),
        apiClient.get('/dashboard_premium/top_clientes'),
        apiClient.get('/dashboard_premium/ventas_por_mes'),
      ]);
      const kpisData = r1 || null;
      const tp = (r2 && Array.isArray(r2.top_productos)) ? r2.top_productos : [];
      const tc = (r3 && Array.isArray(r3.top_clientes)) ? r3.top_clientes : [];
      const vm = (r4 && Array.isArray(r4.ventas_por_mes)) ? r4.ventas_por_mes : [];

      setKpis(kpisData);
      setTopProductos(tp);
      setTopClientes(tc);
      setVentasPorMes(vm);
    } catch (e) {
      setErr((e && e.message) || 'Error al cargar el dashboard');
      setKpis(INITIAL_KPIS);
      setTopProductos(INITIAL_LIST);
      setTopClientes(INITIAL_LIST);
      setVentasPorMes(INITIAL_LIST);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return {
    kpis,
    topProductos,
    topClientes,
    ventasPorMes,
    loading,
    err,
    reload: load,
  };
}
